<template>
<div class="chapter">
<div class="inner_page">
<p class="fn1"><span><i>I give glory to God</i>.</span></p>
<p class="fn2"><span><i>I give thanks for love</i>.</span></p>
<p class="fn2"><span><i>I am deeply grateful for the patience and support of</i></span></p>
<p class="fn2"><span><i>my friend and agent, Aaron Priest</i>.</span></p>
<p class="fn2"><span><i>Thanks to Marc Resnick, my wonderful editor</i>,</span></p>
<p class="fn2"><span><i>and the other good folks at St. Martin’s Press</i>.</span></p>
<p class="fn2"><span><i>And blessings and peace be upon you, dear reader</i>,</span></p>
<p class="fn2"><span><i>and on us all</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?27fa5efe